/* tslint:disable */
/* eslint-disable */
/**
 * BloomRegistration.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewClassSessionWaitlistSubmissionDto
 */
export interface NewClassSessionWaitlistSubmissionDto {
    /**
     * 
     * @type {string}
     * @memberof NewClassSessionWaitlistSubmissionDto
     */
    classSessionId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewClassSessionWaitlistSubmissionDto
     */
    studentIds?: Array<string> | null;
}

export function NewClassSessionWaitlistSubmissionDtoFromJSON(json: any): NewClassSessionWaitlistSubmissionDto {
    return NewClassSessionWaitlistSubmissionDtoFromJSONTyped(json, false);
}

export function NewClassSessionWaitlistSubmissionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewClassSessionWaitlistSubmissionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classSessionId': !exists(json, 'classSessionId') ? undefined : json['classSessionId'],
        'studentIds': !exists(json, 'studentIds') ? undefined : json['studentIds'],
    };
}

export function NewClassSessionWaitlistSubmissionDtoToJSON(value?: NewClassSessionWaitlistSubmissionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classSessionId': value.classSessionId,
        'studentIds': value.studentIds,
    };
}

